// extracted by mini-css-extract-plugin
module.exports = {"loadButton":"load-button-module--loadButton--2hp4-"};